const actionTypes = {
  FetchReviewStats: 'FETCH_REVIEW_STATS',
  FetchReviewStatsByRating: 'FETCH_REVIEW_STATS_BY_RATING',
};

export default actionTypes;
